export default {
  computed: {
    isBackend () {
      return this.$route.path.includes('/wecom-ext-groups')
    },
  },
  created () {
    const actions = []
    actions.push({
      label: this.$t('scope.join_group_qrcode'),
      action: (row) => {
        this.createDialog('WecomExtGroupsQrcodeDialog', {
          title: this.$t('scope.join_group_qrcode'),
          onManager: this.onManager,
          chat_id: row.id,
        })
      },
      meta: (obj) => {
        return {
          validate: true,
        }
      },
      hidden: (obj) => !this.isBackend,
    })
    actions.push({
      label: this.$t('compute.perform_sync_status'),
      permission: 'wecom_ext_groups_perform_sync',
      action: (obj) => {
        this.onManager('performAction', {
          id: obj.id,
          managerArgs: {
            action: 'sync',
          },
        })
      },
      meta: () => {
        const ret = {
          validate: false,
          tooltip: null,
        }
        ret.validate = true
        return ret
      },
      hidden: (obj) => !this.isBackend,
    })
    actions.push({
      label: this.$t('scope.wecom.group.perform_ready'),
      permission: 'wecom_ext_groups_perform_ready',
      action: (obj) => {
        this.createDialog('WecomExtGroupReadyDialog', {
          title: this.$t('scope.wecom.group.perform_ready'),
          onManager: this.onManager,
          data: [obj],
          columns: this.columns,
        })
      },
      meta: (obj) => {
        const ret = {
          validate: false,
          tooltip: null,
        }
        if (obj.enabled && obj.associate_count === 0) {
          ret.validate = true
        }
        return ret
      },
      hidden: (obj) => !this.isBackend,
    })
    this.singleActions = actions
  },
}
